import { RANGES } from "../Planners";
export const dexfProdKeys = {
    [RANGES.AURDAL]: "f0b44905-880e-4737-b252-f45dfe760ceb",
    [RANGES.BROR]: "9b8125dd-7d31-4a73-9a79-dcfd462bc749",
    [RANGES.BOAXEL]: "7247c3db-9664-4fd1-a9eb-b4d90938a37f",
    [RANGES.IVAR]: "411b3ce1-2f68-46e8-886f-4f08c63ecfcc",
    [RANGES.JONAXEL]: "285253d8-2ec3-4a18-84d7-42b1678607fe",
    [RANGES.ELVARLI]: "094b01b5-b441-4ed2-9142-1d84d47f8949",
    [RANGES.ADDONS_KALLAX]: "411b3ce1-2f68-46e8-886f-4f08c63ecfcc",
};
export const dexfQaKey = {
    shared: "829e294e-1e25-4f81-975e-ad53ac4a3682",
};
export const getDexfApiKey = (appId, isProduction) => !isProduction
    ? dexfQaKey.shared
    : dexfProdKeys[appId.toLowerCase()];
